import { doorSettingsStateStore } from './redux-service';
import { loadDoorSettingsState } from './localStorage-service';

const languageJSON = require('../../../json/language.json');
const aaecState = require('../../../json/state/aaec-state.json');

export const languageService = (() => {

	const presetClimate = {
		en: "United Kingdom",
		noNO: "Norway",
		daDK: "Denmark",
		deDE: "Germany",
	}
	const videoLang = {
		en: "/assets/videos/ENG_assa_ENCALC.mp4",
		noNO: "/assets/videos/NO_assa_ENCALC.mp4",
		daDK: "/assets/videos/DK_assa_ENCALC.mp4",
		deDE: "/assets/videos/DE_assa_ENCALC.mp4",
	}

	const $languageSelector = $(".select-language");
	const $elementWithTextLanguageClass = $(".lang");
	let languageCodeSelectorValue = $(".select-language").val();
	let textLanguageKey = "";
	let doorState = aaecState;
	let GetUrlHash = window.location.hash.substring(1).replace(/-/g, "");
	let $selectCountry = $('.select-country');
	let $hubspotWrapper = $('.hubspot-wrapper');

	//let $selectCurrency = $('.select-currency');

	if (loadDoorSettingsState() !== undefined) {
		doorState = loadDoorSettingsState();
	}
	if (GetUrlHash == "") {
		GetUrlHash = "en";
	}

	$languageSelector.val(GetUrlHash);
	languageCodeSelectorValue = GetUrlHash;
	// Get right text on each element with text-language class from the languge json file
	doorSettingsStateStore.dispatch({ type: 'CHANGE_LANGUAGE', language: languageCodeSelectorValue });

	languageFunction(languageCodeSelectorValue);
	//console.log(doorState.language);
	// Change language 

	if ($(".select-currency option[id='" + window.location.hash.substring(1) + "']").length > 0) {
		var getValue = $(".select-currency option[id='" + window.location.hash.substring(1) + "']").val();
		$(".select-currency").val(getValue);
	} else {
		$(".select-currency").val('EUR');
	}

	$hubspotWrapper.each(function(e){
		if($(this).data().hubspot == GetUrlHash){
			$(this).show();
		} else{
			$(this).hide();
		}
	})

	//Sets the region of active language
	$selectCountry.val(presetClimate[languageCodeSelectorValue]).trigger('change');
	
	$("#watch-a-video-iframe source").attr('src', videoLang[languageCodeSelectorValue]);
	
	$languageSelector.on('change', function (e) {
		let languageCodeSelectorValue = this.value.replace(/-/g, "");
		window.location.hash = this.value;
		doorSettingsStateStore.dispatch({ type: 'CHANGE_LANGUAGE', language: languageCodeSelectorValue })
		languageFunction(languageCodeSelectorValue);

		if ($(".select-currency option[id='" + window.location.hash.substring(1) + "']").length > 0) {
			var getValue = $(".select-currency option[id='" + window.location.hash.substring(1) + "']").val();
			$(".select-currency").val(getValue).trigger('change');
		} else {
			$(".select-currency").val('EUR').trigger('change');
		}

		//Sets the region of active language
		$selectCountry.val(presetClimate[languageCodeSelectorValue]).trigger('change');
		$("#watch-a-video-iframe source").attr('src', videoLang[languageCodeSelectorValue]);
		$languageSelector.val(languageCodeSelectorValue);

		$hubspotWrapper.each(function(e){
			if($(this).data().hubspot == languageCodeSelectorValue){
				$(this).show();
			} else{
				$(this).hide();
			}
		})
		$("#watch-a-video-iframe")[0].load();
	});

	function languageFunction(languageCodeSelectorValue) {

		$elementWithTextLanguageClass.each(function () {
			let $this = $(this);
			let textLanguageKey = $this.data("text-language");

			// If variable textLanguageKey from data-text-language attribute includes a . in it (path separation to find the right keyvalue in lang json file)
			// this code is only made for 3 levels depth in json array of each lang
			if (textLanguageKey.indexOf('.') > -1) {
				let textLanguageKeyArray = textLanguageKey.split(".");
				let xPathWays = textLanguageKeyArray.length

				//changed $this.text to $this.html so that you can put html into the json
				switch (xPathWays) {
					case 2:
						$this.html(languageJSON[languageCodeSelectorValue][textLanguageKey.split(".")[0]][textLanguageKey.split(".")[1]]);
						break;
					case 3:
						$this.html(languageJSON[languageCodeSelectorValue][textLanguageKey.split(".")[0]][textLanguageKey.split(".")[1]][textLanguageKey.split(".")[2]]);
						break;
				}
			} else {
				$this.html(languageJSON[languageCodeSelectorValue][textLanguageKey]);
			}

		});

	}
	$("#watch-a-video-iframe")[0].load();
})();



// WEBPACK FOOTER //
// ./src/assets/scripts/service/language-service.js